<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container">
        <div class="notice-title" :title="pageData.title">
          {{ pageData.title }}
        </div>
        <div class="color-1">
          <span class="pr20" :title="pageData.source" v-if="pageData.source"
            >来源：{{ pageData.source }}</span
          >
          <!-- <span class="pr20" v-else-if="!source || source == 2"
            >来源：【信息发布】</span
          >
          <span class="pr20" v-else-if="source == '5' || source == '6'"
            >来源：【我的钢铁】</span
          > -->
          <span class="pr20" :title="pageData.author" v-if="pageData.author"
            >作者：{{ pageData.author }}</span
          >
          <span class="pr20">发布日期：{{ pageData.publishTime }}</span>
          <span class="pr20" :title="pageData.publishedBy" v-if="source === '0'"
            >发布单位：{{ pageData.publishedBy }}</span
          >
        </div>
        <el-divider></el-divider>
        <div
          class="textContent"
          v-html="pageData.textContent"
          style="line-break: anywhere;"
        ></div>
        <!-- 附件信息 -->
        <!--通知公告和工作动态不显示附件说明字段。 source 为空默认为通知公告-->
        <attachmentUpload
          v-if="fileData.length > 0"
          class="pt20"
          :type="2"
          :fileData="fileData"
          :isShowDesc="
            !(
              !source ||
              source === announcementPageSource.notice ||
              source === announcementPageSource.dynamicWork ||
              source === announcementPageSource.supplierRecommend
            )
          "
        ></attachmentUpload>
      </div>
    </div>
  </div>
</template>

<script>
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
import attachmentUpload from "@/basa/components/common/attachmentUpload";
import { announcementPageSource } from "@/setting/setting";
import moment from "moment";
export default {
  name: "commonAnnouncementDetail",
  components: {
    baseBreadCrumb,
    attachmentUpload
  },
  props: {
    pageData: {
      type: Object,
      default: () => {}
    },
    currBreadCrumb: {
      type: Array,
      default: () => []
    },
    fileData: {
      type: Array,
      default: () => []
    },
    source: {
      type: String,
      default: ""
    },
    publishedBy: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      announcementPageSource: announcementPageSource,
      moment: moment
    };
  },
  mounted() {
    console.log(this.currBreadCrumb, "currBreadCrumb");
  }
};
</script>

<style lang="scss" scoped>
/deep/ .textContent {
  width: 100%;
}
/deep/ .textContent {
  img {
    width: 100% !important;
  }
  table {
    width: 100% !important;
  }
}
.notice-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.pr20 {
  display: inline-block;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
